import React, { useEffect, useState } from "react";
import CommonDivWidget from "components/CommonDivWidget/CommonDivWidget";
import { message, Spin, Row, Col } from "antd";
import CommonButton from "components/ButtonWidgets/CommonButton/CommonButton";
import TableWidget from "./TableWidget/TableWidget";
import { showZoneEditorDialog } from "./ZoneEditorDialog/showZoneEditorDialog";
import {
  apiGetShippingZoneList,
  apiCreateShippingZone,
  apiUpdateShippingZone,
  apiDeleteShippingZone,
} from "services/shopShippingZoneService";

function ShopShippingZoneListPage() {
  const [isBusy, setIsBusy] = useState(false);
  const [dataList, setDataList] = useState([]);

  const loadZones = () => {
    setIsBusy(true);
    apiGetShippingZoneList()
      .then((data) => {
        setIsBusy(false);
        setDataList(data || []);
      })
      .catch((err) => {
        setIsBusy(false);
        setDataList([]);
        message.error("Sorry! " + err);
      });
  };

  useEffect(() => {
    loadZones();
  }, []);

  const onNewZone = async () => {
    var res = await showZoneEditorDialog({ title: "New Shipping Zone", isEditing: false });
    if (res === null) return;
    setIsBusy(true);
    apiCreateShippingZone(res)
      .then((data) => {
        setIsBusy(false);
        setDataList([...dataList, data]);
      })
      .catch((err) => {
        setIsBusy(false);
        message.error("Error! " + err);
      });
  };

  const onClickEdit = async (pInfo) => {
    var res = await showZoneEditorDialog({ title: "Edit Shipping Zone", record: pInfo, isEditing: true });
    if (res === null) return;
    setIsBusy(true);
    apiUpdateShippingZone(pInfo.id, res)
      .then((data) => {
        setIsBusy(false);
        let updateData = [...dataList];
        var idx = updateData.findIndex((x) => x.id == data.id);
        updateData.splice(idx, 1, data);
        setDataList(updateData);
      })
      .catch((err) => {
        setIsBusy(false);
        message.error(err);
      });
  };

  const onClickDelete = (pInfo) => {
    setIsBusy(true);
    apiDeleteShippingZone(pInfo.id)
      .then(() => {
        setIsBusy(false);
        setDataList(dataList.filter((x) => x.id != pInfo.id));
      })
      .catch((err) => {
        setIsBusy(false);
        message.error(err);
      });
  };

  return (
    <CommonDivWidget>
      <Spin spinning={isBusy}>
        <h1>International Shipping Zones</h1>
        <p style={{ color: "var(--darkGreyColor)", maxWidth: 720 }}>
          Weight-based shipping (Thailand Post ePacket) for countries outside Thailand. Each zone has its
          own weight brackets and charges — add a new zone here (e.g. once a Singapore/Hong Kong rate
          table is available) without any code changes.
        </p>
        <Row>
          <Col flex={"auto"} />
          <Col>
            <div style={{ fontFamily: "mediumFont", padding: 20 }}>
              <CommonButton onClick={onNewZone}>New Zone</CommonButton>
            </div>
          </Col>
        </Row>

        <div style={{ paddingTop: 16 }}>
          <TableWidget dataList={dataList} onUpdateAction={onClickEdit} onDeleteAction={onClickDelete} />
        </div>
      </Spin>
    </CommonDivWidget>
  );
}

export default ShopShippingZoneListPage;
